"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Select = _interopRequireDefault(require("../Select"));

var _styles = require("../styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var PageSizeList =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(PageSizeList, _PureComponent);

  function PageSizeList(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = PageSizeList.prototype;

  _proto.handleChange = function handleChange(pageSize) {
    var _this$props = this.props,
        current = _this$props.current,
        onChange = _this$props.onChange;
    var start = (current - 1) * this.props.pageSize + 1;
    onChange(Math.ceil(start / pageSize), pageSize);
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        pageSize = _this$props2.pageSize,
        pageSizeList = _this$props2.pageSizeList,
        text = _this$props2.text,
        disabled = _this$props2.disabled,
        size = _this$props2.size,
        _this$props2$sizeList = _this$props2.sizeListProps,
        sizeListProps = _this$props2$sizeList === void 0 ? {} : _this$props2$sizeList;
    return _react.default.createElement(_Select.default, _extends({
      onChange: this.handleChange,
      disabled: disabled,
      absolute: true,
      autoAdapt: true,
      keygen: true,
      value: pageSize,
      size: size,
      className: (0, _styles.paginationClass)('section', 'pagesize'),
      data: pageSizeList,
      renderItem: function renderItem(d) {
        return d + " " + (text.page || '');
      }
    }, sizeListProps));
  };

  return PageSizeList;
}(_react.PureComponent);

PageSizeList.propTypes = {
  current: _propTypes.default.number.isRequired,
  disabled: _propTypes.default.bool,
  onChange: _propTypes.default.func.isRequired,
  pageSize: _propTypes.default.number.isRequired,
  pageSizeList: _propTypes.default.array,
  text: _propTypes.default.object.isRequired,
  size: _propTypes.default.string,
  sizeListProps: _propTypes.default.object
};
PageSizeList.defaultProps = {
  pageSizeList: [10, 20, 30, 50, 100]
};
var _default = PageSizeList;
exports.default = _default;